export default "<div layout=\"row\">\r\n\t<div fxFlex>\r\n\t\t<pp-professional-dashboard></pp-professional-dashboard>\r\n\t</div>\r\n</div>\r\n"